import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class JsonLdService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  /**
   * Injects JSON-LD structured data into the document head.
   * @param data The structured data object (Schema.org)
   */
  setData(data: any) {
    let script = this.document.querySelector('script[type="application/ld+json"]');
    if (!script) {
      script = this.document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      this.document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
  }

  /**
   * Clears the current JSON-LD script content.
   */
  clearData() {
    const script = this.document.querySelector('script[type="application/ld+json"]');
    if (script) {
      script.textContent = '';
    }
  }

  /**
   * Generates a BreadcrumbList JSON-LD object.
   * @param items Breadcrumb items
   */
  getBreadcrumbSchema(items: { name: string, item: string }[]) {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": item.item
      }))
    };
  }

  /**
   * Generates an Organization JSON-LD object.
   */
  getOrganizationSchema() {
    return {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "pakmatti.com",
      "url": "https://pakmatti.com",
      "logo": "https://pakmatti.com/assets/images/logo.png",
      "sameAs": [
        "https://www.facebook.com/mattipk",
        "https://twitter.com/mattipk",
        "https://www.instagram.com/mattipk"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+92-XXX-XXXXXXX",
        "contactType": "customer service"
      }
    };
  }
}
